module.exports = __webpack_public_path__ + "media/pages/banner_01-f4bf3233.jpg";